// Assistant route: cited answers from the loaded grid code with the thread, requirement, version, Assessment topics, control functions, section priorities and one-shot question hand-off in the URL.
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { optionalList, optionalString } from "@/app/search";
import { PRIORITIES } from "@/components/common/PriorityBadge";
import { AssistantScreen } from "@/features/assistant/AssistantScreen";

const searchSchema = z.object({
  thread: optionalString(),
  req: optionalString(),
  doc: optionalString(),
  topic: optionalList(z.string()),
  control: optionalList(z.string()),
  priority: optionalList(z.enum(PRIORITIES)),
  ask: optionalString(),
});

export const Route = createFileRoute("/_app/$region/assistant")({
  validateSearch: searchSchema,
  staticData: { crumb: "Assistant" },
  component: AssistantRoute,
});

function AssistantRoute() {
  return <AssistantScreen search={Route.useSearch()} />;
}
